import { Monogram } from '../components/Monogram';
import { Reveal } from '../components/Reveal';
import { RSVP_COMING_SOON, comingSoon, couple, day, rsvp, venue } from '../content/wedding';

export function Closing() {
  return (
    <section class="closing">
      <div class="shell">
        <Reveal>
          <Monogram class="closing__crest" />
        </Reveal>
        <Reveal delay={100}>
          <h2>
            {couple.one.first} <span class="amp">&amp;</span> {couple.two.first}
          </h2>
          <p class="closing__date">
            {day.dateShort} &middot; {venue.place}
          </p>
        </Reveal>
        <Reveal delay={200}>
          {RSVP_COMING_SOON ? (
            <p class="closing__note">{comingSoon.rsvpNote}</p>
          ) : (
            <>
              <a class="btn btn--onForest" href="/rsvp" style={{ marginTop: '2.5rem' }}>
                RSVP
              </a>
              <p class="closing__note">Kindly reply {rsvp.deadline}</p>
            </>
          )}
        </Reveal>
      </div>
    </section>
  );
}
